/* eslint-disable @typescript-eslint/no-unused-vars */
import { Moment } from "moment";
import { useState, useEffect } from "react";
import { CSSProperties } from "styled-components";
import { getDebugLogger } from "../../../utils/debugLogger";
import { Box, Number, Separator, Text, Wrapper } from "./styles";
import { getCount, ICount, pad } from "utils/time";

const debug = getDebugLogger({
	isEnabled: true
});

const getDisplay = (count: ICount) => {
	const { years, months, weeks, days, hrs, mins, secs } = count;
	if (secs < 0) {
		return "";
	}

	let newDisplay = "";

	switch (true) {
		// TODO: add "fall through" comments to pass linter
		case !!years: // fall through
		case !!months: // fall through
		case !!weeks:
		case !!days:
			// | "6d 23h 59m"
			newDisplay = `${days}d ${hrs}h ${pad(mins)}m`;
			break;

		case !!hrs:
			// | "23h 59m 59s"
			newDisplay = `${hrs}h ${mins}m ${pad(secs)}s`;
			break;

		case !!mins:
			// | "59m 59s"
			newDisplay = `${mins}m ${pad(secs)}s`;
			break;

		case !!secs: // fall through
		default:
			// | "0m 59s"
			newDisplay = `${mins}m ${secs}s`;
	}
	return newDisplay;
};

const TimerDisplay = ({
	startTime,
	endTime,
	onEnd,
	status,
	style
}: {
	style?: CSSProperties;
	startTime: Moment | null;
	endTime: string;
	onEnd: () => void;
	status?: string;
}) => {
	const count = getCount(startTime, endTime);
	const [display, setDisplay] = useState<string>(getDisplay(count));

	useEffect(() => {
		setDisplay(getDisplay(count));
	}, [status]);

	useEffect(() => {
		const intervalId = setInterval(() => {
			const newCount = getCount(startTime, endTime);
			if (newCount.totalSeconds <= 0) {
				debug.logUseEffect({
					iconText: "TimerDisplay",
					message: ["\nuseEffect( countdown_ended, []", []]
				});
				onEnd();
				clearInterval(intervalId);
			}
			setDisplay(getDisplay(newCount));
		}, 1000);
		return () => clearInterval(intervalId);
	}, [status, startTime, endTime]);

	return (
		<Wrapper style={style} data-testid="timerDisplay">
			<Box>
				<Number style={{ paintOrder: "stroke fill" }}>
					{display.split(" ")[0]?.match(/\d/g) || "0"}
				</Number>
				<Text style={{ paintOrder: "stroke fill" }}>
					{display.split(" ")[0]?.match(/[a-zA-Z]/g)}
				</Text>
			</Box>

			{(display.split(" ")[1]?.match(/\d/g)?.length || 0) > 0 && (
				<>
					<Separator style={{ paintOrder: "stroke fill" }} />
					<Box>
						<Number style={{ paintOrder: "stroke fill" }}>
							{display.split(" ")[1]?.match(/\d/g) || "0"}
						</Number>
						<Text style={{ paintOrder: "stroke fill" }}>
							{display.split(" ")[1]?.match(/[a-zA-Z]/g)}
						</Text>
					</Box>
				</>
			)}

			{(display.split(" ")[2]?.match(/\d/g)?.length || 0) > 0 && (
				<>
					<Separator style={{ paintOrder: "stroke fill" }} />
					<Box>
						<Number style={{ paintOrder: "stroke fill" }}>
							{display.split(" ")[2]?.match(/\d/g) || "0"}
						</Number>
						<Text style={{ paintOrder: "stroke fill" }}>
							{display.split(" ")[2]?.match(/[a-zA-Z]/g)}
						</Text>
					</Box>
				</>
			)}
		</Wrapper>
	);
};

export default TimerDisplay;
